import React from "react";
import EminevimLoading from "../shared/EminevimLoading";

export function LoginPageLoadingIndicator({ active, subtext }) {
  if (!active) {
    return null;
  }

  return (
    <div className="t-loginPage-loadingOverlay" role="status" aria-live="polite" aria-busy="true">
      <EminevimLoading subtext={subtext} compact />
    </div>
  );
}

export default LoginPageLoadingIndicator;
